import * as React from "react"

const MOBILE_BREAKPOINT = 768 // md breakpoint in Tailwind by default
const MOBILE_QUERY = `(max-width: ${MOBILE_BREAKPOINT - 1}px)`

const getSnapshot = () => {
  if (typeof window === "undefined") return false
  return window.matchMedia(MOBILE_QUERY).matches
}

export function useIsMobile() {
  const isMobile = React.useSyncExternalStore(
    (onStoreChange) => {
      if (typeof window === "undefined") return () => {}
      const mql = window.matchMedia(MOBILE_QUERY)
      const onChange = () => onStoreChange()

      try {
        mql.addEventListener("change", onChange)
      } catch {
        try {
          mql.addListener(onChange)
        } catch (e) {
          console.error("Error adding media query listener for useIsMobile", e)
        }
      }

      return () => {
        try {
          mql.removeEventListener("change", onChange)
        } catch {
          try {
            mql.removeListener(onChange)
          } catch {
            // ignore cleanup errors for legacy browsers
          }
        }
      }
    },
    getSnapshot,
    () => false
  )

  const [isClient, setIsClient] = React.useState(false)

  React.useEffect(() => {
    setIsClient(true)
  }, [])

  return isClient ? isMobile : false
}
